/** API route map: URLS.Controller.EEOPositionGroup */
export const EEOPositionGroup = {
      Name: 'EeoPositionGroup/',
      GetAllPaginated: 'get-all-paginated',
      GetClassCodes: 'get-class-code',
      Add: 'add',
      Update: 'update',
      Delete: 'delete',
};
